import {
  StatusActive, StatusScheduled, StatusSuccess
} from '@liveramp/motif/icons';
import React, { useCallback, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CampaignStatus } from '../filterOptions.enum';
import getStyles from '../modalsStyle.override';

const initialStatusOptions = [
  {
    text: CampaignStatus.notStarted,
    Icon: StatusScheduled,
    checked: false
  },
  {
    text: CampaignStatus.inFlight,
    Icon: StatusActive,
    checked: false
  },
  {
    text: CampaignStatus.complete,
    Icon: StatusSuccess,
    checked: false
  }
];

const useCampaignStatusModalLogic = (
  campaignStatusFilter: CampaignStatus[],
  isDialogOpened: boolean,
  boundingCampaignButtonRect: ClientRect | null
) => {
  const [options, setOptions] = useState(initialStatusOptions.map(opt => ({
    ...opt,
    checked: campaignStatusFilter.includes(opt.text)
  })));

  const useStyles = useCallback(
    makeStyles(getStyles(boundingCampaignButtonRect)),
    [boundingCampaignButtonRect]
  );

  const onOptionChange = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setOptions(
      options.map((opt, mapIndex) => ({
        ...opt,
        checked: index === mapIndex ? event.target.checked : opt.checked
      }))
    );
  };

  useEffect(() => {
    setOptions(initialStatusOptions.map(opt => ({
      ...opt,
      checked: campaignStatusFilter.includes(opt.text)
    })));
  }, [campaignStatusFilter, isDialogOpened]);

  return {
    options,
    onOptionChange,
    useStyles,
    setOptions
  };
};

export default useCampaignStatusModalLogic;
